<template>
  <header class="topbar">
    <div class="container-readable topbar-inner">
      <!-- לוגו האתר -->
      <router-link
        to="/"
        class="brand-link"
        aria-label="BestPhone Home"
      >
        <img
          class="topbar-logo"
          src="@/assets/images/logo.png"
          alt="BestPhone"
        />
      </router-link>

      <!-- פאנל משתמש ופעולות -->
      <div class="inline-row user-actions">
        <!-- פיל שם משתמש -->
        <div
          v-if="userName"
          class="user-pill"
        >
          <svg
            class="pill-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>

          <span class="user-name">
            {{ userName }}
          </span>
        </div>

        <!-- פתיחת פנייה -->
        <router-link
          to="/support-ticket"
          class="btn btn-ghost support-link"
          title="פתיחת פנייה"
          aria-label="פתיחת פנייה לשירות לקוחות"
        >
          <svg
            class="btn-icon"
            width="17"
            height="17"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"></path>
            <line x1="8" y1="9" x2="16" y2="9"></line>
            <line x1="8" y1="13" x2="14" y2="13"></line>
          </svg>

          <span>פתיחת פנייה</span>
        </router-link>

        <!-- קישור ליצירת סיסמה -->
        <router-link
          v-if="showCreatePassword"
          to="/create-password"
          class="btn btn-ghost create-pw-link"
        >
          <svg
            class="btn-icon"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="M21 2l-2 2m-1.5 1.5l-3 3m-2 2l-3 3m-2 2l-3 3M3 21l3-3m0 0l3-3m-3 3l-3-3"></path>
            <circle cx="16.5" cy="7.5" r="3.5"></circle>
          </svg>

          <span>
            {{ get_word('create_password_nav') || 'יצירת סיסמה' }}
          </span>
        </router-link>

        <!-- כפתור יציאה -->
        <router-link
          to="/logout"
          class="btn btn-ghost logout-link"
          title="יציאה מהחשבון"
        >
          <svg
            class="btn-icon"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>

          <span>{{ logoutText }}</span>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppTopbar',

  props: {
    userName: {
      type: String,
      default: ''
    },

    logoutText: {
      type: String,
      default: 'יציאה מהחשבון'
    }
  },

  data() {
    return {
      showCreatePassword: false
    }
  }
}
</script>

<style
  lang="scss"
  scoped
  src="@/styles/components/app-topbar.scss"
></style>